import { type EventFilterCriteria } from "@/schemas/events/filter/EventFilterCriteria";
import { type UserFilterCriteria } from "@/schemas/profile/filters/UserFilterCriteria";

export enum FilterType {
  USER = "user",
  EVENT = "event",
}

export type FilterCriteria = UserFilterCriteria | EventFilterCriteria;
